/**
 * modal id들을 정리한 오브젝트
 * ```
 *  openModal({ id: MODALS_ID.ALERT })
 *  // or
 *  closeModal(MODALS_ID.ALERT)
 * ```
 */
export const MODALS_ID = {
  ALERT: 'ALERT',
  RENDING: 'RENDING',
  WITHDRAWAL_USER_CONFIRM: 'WITHDRAWAL_USER_CONFIRM',
  LOGOUT: 'LOGOUT',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  EMPTY_ADDRESS: 'EMPTY_ADDRESS',
  SUITABLE_NOTICE: 'SUITABLE_NOTICE',
  VERIFICATION_NOTICE: 'VERIFICATION_NOTICE',
  ALREADY_VERIFICATION: 'ALREADY_VERIFICATION',
  IS_SIGNIN: 'IS_SIGNIN',
  CALCULATE: 'CALCULATE',
  CANCEL_PRODUCT: 'CANCEL_PRODUCT',
  CHECK_VERIFICATION: 'CHECK_VERIFICATION',
  ALREADY_WITHDRAWAL_NOTIFY: 'ALREADY_WITHDRAWAL_NOTIFY',
  SUCCESS_CREATED_WITHDRAWAL: 'SUCCESS_CREATED_WITHDRAWAL',
  SUCCESS_CHANGED_WITHDRAWAL: 'SUCCESS_CHANGED_WITHDRAWAL',
  SUCCESS_ADDRESS: 'SUCCESS_ADDRESS',
  NETWORK_ERROR: 'NETWORK_ERROR',
  MISMATCH_USER: 'MISMATCH_USER',
  TERMS_DETAIL: 'TERMS_DETAIL',
  SUCCESS_SIGNUP: 'SUCCESS_SIGNUP',
  ORDER_LOADING: 'ORDER_LOADING',
  ORDER_SUCCESS: 'ORDER_SUCCESS',
  ORDER_FAIL: 'ORDER_FAIL',
  INVEST_SUITABILITY: 'INVEST_SUITABILITY',
  POSTCODE: 'POSTCODE',
  CONDITIONS_OF_SERVICE_TERMS: 'CONDITIONS_OF_SERVICE_TERMS',
  PERSONAL_INFO_PROCESSING_POLICY_TERMS: 'PERSONAL_INFO_PROCESSING_POLICY_TERMS',
  PERSONAL_INFO_TO_A_THIRD_PARTY: 'PERSONAL_INFO_TO_A_THIRD_PARTY',
  PROMOTIONS_SUCH_AS_EVENTS: 'PROMOTIONS_SUCH_AS_EVENTS',
  OPEN_SOURCE_LICENSE: 'OPEN_SOURCE_LICENSE',
  DEVICE_NOTIFY_ALLOW: 'DEVICE_NOTIFY_ALLOW',
  OPEN_SOURCE: 'OPEN_SOURCE',
} as const

type ModalsIds = keyof typeof MODALS_ID

export type { ModalsIds }
